import { useState } from "react";
import { NavLink } from "react-router-dom";

export default function QHSENav(props) {
  const items = [
    {
      name: "Jobs",
      to: "jobs/",
    },
    {
      name: "Documented Information",
      to: `jobs/stages`,
    },
    {
      name: "Maintenance",
      to: `jobs/maintenance`,
    },
    {
      name: "Site Visit",
      to: `jobs/site-visit`,
    },
  ];

  const others = [];

  return (
    <div className="dashboard-tabs innerpage-tabs tier-1 px-4">
      <ul className="nav nav-tabs">
        {items.map((item, index) => (
          <li key={index} className="nav-item">
            <NavLink className={`nav-link ga-nav-tab`} to={item.to}>
              {item.name}
            </NavLink>
          </li>
        ))}
        {others.map((item, index) => (
          <li key={index} className="nav-item">
            <NavLink className={`nav-link ga-nav-tab`} to={item.to}>
              {item.name}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
}
